import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Game from './pages/Game';
import Result from './pages/Result';
import Dashboard from './pages/Dashboard';
import Hostess from './pages/Hostess';
import Sessions from './pages/Sessions';
import Stocks from './pages/Stocks';
import Prizes from './pages/Prizes';
import Participants from './pages/Participants';
import DailyQuotas from './pages/DailyQuotas';

function App() {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/hostess" element={<Hostess />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/prizes" element={<Prizes />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/daily-quotas" element={<DailyQuotas />} />
          <Route path="/play/:token" element={<Game />} />
          <Route path="/result/:token" element={<Result />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
